<template>
  <div class="dropdown">
    <div
      class="profile-container dropdown-toggle cursor-pointer"
      data-bs-toggle="dropdown"
      aria-expanded="false"
    >
      <img
        :src="$user.profile.profile_image ? $user.profile.profile_image : static('metronic/assets/media/images/thumbs/user.png')"
        alt="Profile"
        class="profile-image"
      />
      <span class="profile-name">{{ $user.profile.first_name }}</span>
    </div>
    <ul class="dropdown-menu">
      <li class="">
        <router-link
          custom
          :to="{ name: 'edit_profile', params: { module: $module } }"
          v-slot="{ href, navigate, isActive, isExactActive }"
        >
          <a
            class="dropdown-item"
            :href="href"
            :class="[isActive && 'active', isExactActive && 'active']"
            @click="navigate"
          >
            My Profile</a
          >
        </router-link>
      </li>
      <li class="">
        <router-link
          custom
          :to="{ name: 'my_followings', params: { module: $module } }"
          v-slot="{ href, navigate, isActive, isExactActive }"
        >
          <a
            class="dropdown-item"
            :href="href"
            :class="[isActive && 'active', isExactActive && 'active']"
            @click="navigate"
          >
            My Followings</a
          >
        </router-link>
      </li>
      <li v-if="$user.is_superuser">
        <router-link
          custom
          :to="{ name: 'framework_setup', params: { module: $module } }"
          v-slot="{ href, navigate, isActive, isExactActive }"
        >
          <a
            class="dropdown-item"
            :href="href"
            :class="[isActive && 'active', isExactActive && 'active']"
            @click="navigate"
            >Framework Setup</a
          >
        </router-link>
      </li>
      <li>
        <router-link custom :to="{name: 'my_schedule', params: {module: $module}}"
                             v-slot="{ href, navigate, isActive, isExactActive }">
          
            <a class="dropdown-item" :class="[isActive && 'active', isExactActive && 'active']" :href="href"
               @click="navigate">My Email Schedules
            </a>
        </router-link>
      </li>
      <li>
        <hr class="dropdown-divider" />
      </li>
      <li><a class="dropdown-item cursor-pointer" @click="reportBug">Report Bug</a></li>
      <!-- <li><a class="dropdown-item cursor-pointer" id="sentry-bug-report-btn">Report Bug</a></li> -->
      <li><a class="dropdown-item cursor-pointer" @click="logout">Logout</a></li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    getInitials: "",
  },
  methods: {
    reportBug() {
      console.log('BUG_REPORT::UAM_BUTTON')
      this.$root.openBugReportModal()
    },
    logout() {
      localStorage.removeItem("auth_token");
      window.location.href = "/app/login";
    },
  },
};
</script>
